import axios from 'axios';

import { apiUrl } from 'configs';
import utils from 'utils';
import sendReport from 'new-services/sentryService';

import isEmpty from '../isEmpty';

const GRAB_TOKEN_API = [
  '/otp_request',
  '/otp_confirmation',
  '/register',
  '/loan_offer',
  '/payment_plans',
  '/choose_payment_plan',
  '/otp_misscall_request',
  '/validate-promo-code',
  '/user-experiment-group',
];

const axiosClient = (customConfig) => {
  const client = axios.create({
    baseURL: apiUrl,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    ...customConfig,
  });

  const fetchData = async ({
    method,
    url,
    headers = {},
    body = {},
    params = {},
    withAuth = true,
  }) => {
    let result;
    const token = GRAB_TOKEN_API.includes(url)
      ? utils.store.get('preAuthToken')
      : utils.store.get('token');
    const requestHeaders = {
      ...headers,
      ...(token && withAuth
        ? {
            Authorization: `${
              !GRAB_TOKEN_API.includes(url) ? 'Token ' : ''
            }${token}`,
          }
        : {}),
    };

    try {
      if (['get', 'delete'].includes(method.toLowerCase())) {
        result = await client[method.toLowerCase()](url, {
          headers: requestHeaders,
          params,
        });
      } else {
        result = await client[method.toLowerCase()](url, body, {
          headers: requestHeaders,
        });
      }
    } catch (error) {
      const errResponse = error.response;
      result = errResponse;
      const payload = !isEmpty(body) ? body : params;
      sendReport(error, payload, token);
    }

    return result;
  };

  return fetchData;
};

export default axiosClient;
